//Teacher Posts Array
const initialTeacherPosts =
[
    {
      "id": 1,
      "author": "Mr. Frizzle",
      "date": "August 25th, 2022",
      "title": "Field Trip to the Zoo",
      "body": "Hello Parents! We are so excited about our upcoming trip to the Zoo, the class cannot stop talking about it! We want everyone to be able to experience this awersome opportunity and need your help to do that! Please fill out this Permission Slip Form as soon as possible. We will be sending a reminder closer to the event. ",
      "path": "fieldtrip-form",
      "btnText": "Field Trip Form",
    },
    {
      "id": 2,
      "author": "Principal Rooney",
      "date": "Sept 9th, 2022",
      "title": "3rd Grade Standardized Testing",
      "body": "Hello students!\n Third graders have State Testing on October 7th! Please make sure your studemys have a big breakfast and plenty of rest. We will provide snacks and pencils. Thank you!\nRegards, Principal Rooney"
    },
    {
      "id": 3,
      "author": "Mr. Frizzle",
      "date": "September 10th, 2022",
      "title": "Make Sure to Relax After School",
      "body": "Hello Class! I just wanted to share with you all that I am so proud of all the work you are doing day in and day out. Please make sure to spend a good amount of time relaxing doing the things that you enjoy! See you tomorrow!"
    },
]

export default initialTeacherPosts